import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQ = [
  { q: "Puis-je télécharger mon eBook plusieurs fois ?", a: "Oui. Vous pouvez télécharger votre eBook plusieurs fois, mais uniquement depuis un seul appareil autorisé par achat. Si vous changez d'appareil, vous pouvez faire une demande depuis votre espace client." },
  { q: "Quels moyens de paiement sont disponibles ?", a: "Le paiement par carte bancaire est disponible et sécurisé via Stripe. Apple Pay est proposé lorsque votre appareil et notre prestataire le permettent. Seuls les moyens réellement disponibles vous sont présentés au moment du paiement." },
  { q: "Est-ce un produit physique ?", a: "Non. Il s'agit exclusivement d'un eBook numérique au format PDF. Aucun produit physique ne sera envoyé." },
  { q: "Puis-je être remboursé ?", a: "Nous proposons commercialement une possibilité de remboursement sous 15 jours, sous réserve des conditions définies dans nos CGV. Cette garantie commerciale ne constitue pas une reproduction automatique du droit légal de rétractation. Les CGV précisent les conditions applicables aux contenus numériques." },
  { q: "Comment accéder à mes eBooks après l'achat ?", a: "Dès la confirmation du paiement, vos eBooks sont disponibles dans votre espace client, rubrique « Mes eBooks ». Vous recevez également un e-mail de confirmation." },
  { q: "Sur quels appareils puis-je lire mes eBooks ?", a: "Vos eBooks au format PDF sont consultables sur ordinateur, tablette et smartphone." },
];

export default function Faq() {
  return (
    <div className="max-w-3xl mx-auto px-5 sm:px-8 py-16">
      <p className="font-overline text-terracotta text-center mb-3">Aide</p>
      <h1 className="font-heading text-4xl sm:text-5xl text-ink tracking-tight text-center mb-10">Questions fréquentes</h1>
      <Accordion type="single" collapsible className="w-full">
        {FAQ.map((f, i) => (
          <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-page-${i}`}>
            <AccordionTrigger className="text-left font-heading text-lg text-ink">{f.q}</AccordionTrigger>
            <AccordionContent className="text-ink-muted leading-relaxed">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
